import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Outlet, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./ToDo.min.css";
import axios from 'axios';
import OneTask from './OneTask';
import { ipAddress } from '../../ipAddress';



interface Props {
}

interface Task {
  name: string,
  time: string,
  date: string,
  address: string,
  id: number,
  isDone: number,
  dateEnd: string,
  toDoGroupId: number
}


const OneGroup: React.FC<Props> = () => {
  const [addTask, setAddTask] = useState<boolean>(false);
  const [nameTask, setNameTask] = useState<string>('');
  const [allTasks, setAllTasks] = useState<Task[]>([]);
  const [nameGroup, setNemGroup] = useState<string>('');
  const [idGroup, setIdGroup] = useState<number>(0);
  const [time, setTime] = useState<string>('');
  const [date, setDate] = useState<string>('');
  const [address, setAddress] = useState<string>('');

  const location = useLocation();
  useEffect(() => {
    if (location.state) {
      let dane = location.state as any;
      let dane2 = dane.from;
      //setDataGroup([...dataGroup, { id: dane2.id, name: dane2.name }])
      //{dataGroup[0].id} w div
      // Dopiero za 2 razem widzi dane i daje błąd undefined
      setNemGroup(dane2.name)
      setIdGroup(dane2.id)

    }
  }, [location])


  const confirmTask = (e: React.FormEvent) => {
    e.preventDefault();
    axios.post(ipAddress + '/addTask', {
      name: nameTask,
      time: time,
      date: date ,
      address: address,
      id: Math.random(),
      toDoGroupId: idGroup,
      isDone: 0,
      dateEnd: '',
    }).then(

    )
      .catch(err => {
        console.log(err);
      })

    setAddTask(false);
    setNameTask('');
    setTime('');
    setDate('');
    setAddress('');

  }

  // Download Tasks 
  const downloadTasks = () => {
    axios.post(ipAddress + '/getTasks', {
      toDoGroupId: idGroup,
    })
      .then(response => {
        setAllTasks(response.data);

      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    downloadTasks();
  }, [allTasks])


  const resize = () => {
    let element = document.getElementById("textAreaAddTask")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  const closeAddTask = () => {
    setAddTask(false);
    setNameTask('');
  }

 
  

  return (
    <div className='oneGroup'>
      <div className='title'>

        <Link to='/ToDo'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>

        <span id='title'>{nameGroup}</span>
      </div>
      <div className='toDo2'>
        <Link to='/ToDo/One'>Zaplanowane</Link>
        <Link to='/ToDo/One/Zakonczone' state={{ from: [nameGroup, idGroup] }}>Zakończone</Link>
      </div>

      <Outlet />

      {addTask ?
        (
          <form className='addGroup' onSubmit={(e) => { confirmTask(e) }}>
            <button className='icon' id='close' onClick={() => closeAddTask()} >X</button>
            <p>Dodaj nowe zadanie</p>
            <div className='groupName'>
              <div>
                <label htmlFor="thing">Nazwa: </label>
                <textarea id='textAreaAddTask'
                  rows={1}
                  placeholder='Wpisz nazwę zadania'
                  value={nameTask}
                  onChange={(e) => (resize(), setNameTask(e.target.value))}
                  required
                ></textarea>
              </div>
              <div>
                <label htmlFor='time'>Godzina:</label>
                <input type="time" name='time' id='time' onChange={(e) => setTime(e.target.value)} />
              </div>
              <div>
              <label htmlFor='time'>Data:</label>
              <input type="date" name='date' id='date' onChange={(e) => setDate(e.target.value)} />
              </div>
              <div>
              <label htmlFor='time'>Adres:</label>
              <input type="text" name='address' id='address' onChange={(e) => setAddress(e.target.value)}/>
              </div>
              

            
            </div>


            <div className='newLine'>
              <button type='submit' id='submit' >OK</button>

            </div>
          </form>
        ) :
        (
          <div></div>
        )

      }

      <div className='allTasks'>{
        allTasks.map((task) => (
          <OneTask task={task} key={task.id} />
        )

        )
      }</div>
      <footer>
        <button type='button' onClick={() => setAddTask(true)} id='circle'><p>+</p></button>
      </footer>


    </div>
  )
}

export default OneGroup